module.exports = __webpack_public_path__ + "assets/pdf/syrah.6a69f805.pdf";